import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Checkbox from './Checkbox';
import CheckboxGroup from './CheckboxGroup';

function CheckboxDemo() {
  const [value, setValue] = React.useState<string[]>([]);

  const handleChange = (event: any, values: string[]) => {
    setValue(values);
  };

  return (
    <Container>
      <Container className="mt-10">
        <Row>
          <Col className="d-flex flex-column">
            <h4>Default Checkboxes</h4>
            <CheckboxGroup
              name={'no-labels'}
              value={value}
              onChange={handleChange}
            >
              <Checkbox
                value={'v-1'}
                variant="xl"
                id={'2'}
                className="mt-6"
              />
              <Checkbox
                value={'v-2'}
                variant="xl"
                id={'3'}
                className="mt-6"
              />
              <Checkbox
                id={'4'}
                value={'v-3'}
                variant="sm"
                className="mt-6"
                disabled
              />
            </CheckboxGroup>
          </Col>
          <Col className="d-flex flex-column">
            <h4>Checkbox - Group with labels</h4>
            <CheckboxGroup
              name={'with-labels'}
              value={value}
              onChange={handleChange}
            >
              <Checkbox
                id={'5'}
                value={'vt-1'}
                variant="xl"
                label={'Checkbox with label'}
                className="mt-6"
              />
              <Checkbox
                id={'6'}
                value={'vt-2'}
                variant="xl"
                label={'Checkbox with label - checked'}
                className="mt-6"
              />
              <Checkbox
                id={'7'}
                value={'vt-3'}
                variant="sm"
                label={'Checkbox with label - disabled'}
                className="mt-6"
                disabled
              />
            </CheckboxGroup>
          </Col>
          <Col className="d-flex flex-column">
            <h4>Checkbox - Stand Alone Checkboxes</h4>
            <Checkbox
              id={'1'}
              name={'no-label-selected'}
              value={'test-1'}
              className="mt-6"
              variant="xl"
              checked
            />
            <Checkbox
              id={'8'}
              name={'no-label-no-selected'}
              value={'test-1'}
              className="mt-6"
              variant="xl"
            />
            <Checkbox
              id={'9'}
              name={'checked'}
              value={'test-2'}
              label={'Checkbox with label - default'}
              variant="xl"
              className="mt-6"
            />
            <Checkbox
              id={'10'}
              name={'checked'}
              value={'test-2'}
              variant="sm"
              label={'Checkbox with label - selected'}
              checked
              className="mt-6"
            />
            <Checkbox
              id={'11'}
              name={'disabled-checkbox'}
              value={'test-3'}
              variant="sm"
              label={'Checkbox with label - disabled'}
              className="mt-6"
              disabled
            />
          </Col>
        </Row>
        <div>
          <h4 tabIndex={0}>Checkbox Buttons</h4>
          <div className='mt-6 d-flex justify-content-between'>
            <CheckboxGroup
                name={'with-labels'}
                value={value}
                onChange={handleChange}
              >
                <Checkbox
                  id={'b1'}
                  value={'bt-1'}
                  variant="sm"
                  label={'Email'}
                  isCheckBoxButton
                />
                <Checkbox
                  id={'b2'}
                  value={'bt-2'}
                  variant="sm"
                  label={'mail'}
                  isCheckBoxButton
                />
                <Checkbox
                  id={'b3'}
                  value={'bt-3'}
                  variant="sm"
                  label={'Text'}
                  disabled
                  isCheckBoxButton
                />
            </CheckboxGroup>
          </div>
        </div>
      </Container>
    </Container>
  );
}

export default CheckboxDemo;
